if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.prevButton = this.querySelector('.slider-buttons-desktop .slider-button--prev');
        this.nextButton = this.querySelector('.slider-buttons-desktop .slider-button--next');
        this.mediaItems = Array.from(this.elements.viewer.querySelectorAll('.custom-media-desktop .slider__slide[data-media-id]'));
        this.currentIndex = this.mediaItems.findIndex(el => el.classList.contains('is-active'));

        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
          this.nextButton.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
          this.updateNavButtons();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);

        this.currentIndex = this.mediaItems.findIndex(
          (item) => item.dataset.mediaId === event.detail.currentElement.dataset.mediaId
        );
        this.updateNavButtons();
      }

      setActiveMedia(mediaId, prepend) {
        const allMedia = this.elements.viewer.querySelectorAll('li[data-media-id]');
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        allMedia.forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.currentIndex = Array.from(allMedia).indexOf(activeMedia);
        this.updateNavButtons();

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
            deferredMedia.loadContent(false);
            if (this.dataset.desktopLayout === 'thumbnail_slider') {
              const tryToPlay = () => {
                const videoElement = deferredMedia.querySelector('video, iframe');
                if (!videoElement) return;
                if (videoElement.tagName === 'VIDEO') {
                  videoElement.muted = true;
                  const playPromise = videoElement.play();

                  if (playPromise !== undefined) {
                    playPromise.catch(error => {
                      videoElement.controls = true;
                    });
                  }
                }
              };
              tryToPlay();
              setTimeout(tryToPlay, 300);
            }
          }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      goToSlide(index) {
        if (index < 0 || index >= this.mediaItems.length) return;
        const target = this.mediaItems[index];
        const mediaId = target.dataset.mediaId;

        this.setActiveMedia(mediaId, false);
        this.currentIndex = index;
        this.updateNavButtons();
      }

      updateNavButtons() {
        if (!this.prevButton || !this.nextButton) return;
        this.prevButton.disabled = this.currentIndex <= 0;
        this.nextButton.disabled = this.currentIndex >= this.mediaItems.length - 1;
      }
    }
  );
}
